import React from "react"

import ApplicationStepper from "@/components/application/ApplicationStepper"
import DocumentUpload from "@/components/application/DocumentUpload"
import AppLayout from "@/components/layout/AppLayout"

const DocumentsPage = () => {
  return (
    <AppLayout>
      <div className="container mx-auto px-4 pb-8 md:px-8">
        <ApplicationStepper />

        <h1 className="mb-2 text-center text-2xl font-bold text-jungle md:text-2xl">
          Document Verification
        </h1>
        <p className="mb-8 text-center text-gray-600">
          Please provide the required documents to verify your eligibility
        </p>

        <div className="mx-auto max-w-2xl">
          <DocumentUpload />
        </div>
      </div>
    </AppLayout>
  )
}

export default DocumentsPage
